import {
  blackColor,
  whiteColor,
} from 'assets/jss/material-dashboard-pro-react';
import chroma from 'chroma-js';

export const nonOperatingEvent = (disabledDay, t) => ({
  title: t('common.dayNotSupported'),
  start: new Date(disabledDay),
  end: new Date(disabledDay),
  color: whiteColor,
  shadow: 'none',
  height: '70px',
  fontColor: '#f44336',
});

export const dietEvent = (el, component) => {
  let fontColor;
  const minContrast = 4.5;
  if (chroma.contrast(el.diet?.color ?? '#223649', whiteColor) > minContrast) {
    fontColor = whiteColor;
  } else {
    fontColor = blackColor;
  }
  return {
    state: el.state,
    newState: el.newState,
    type: el['@type'],
    start: new Date(el.date),
    end: new Date(el.date),
    title: component,
    allDay: true,
    color: el.diet?.color ?? '#223649',
    fontColor,
    iri: el['@id'],
    id: el.id,
    variant: 'diet',
  };
};
